// extracted by mini-css-extract-plugin
module.exports = {"select_category":"CategoryFilter_select_category__1E5KV"};